import React from 'react';
import { COMPARISON } from './prosopologiaData';

export default function ComparisonTable() {
  return (
    <div className="overflow-x-auto rounded-card border border-brown/15 bg-ivory">
      <table className="w-full text-left text-body-s min-w-[560px]">
        <thead className="bg-warm-black text-cream">
          <tr>
            <th className="p-4 font-medium" scope="col"></th>
            <th className="p-4 font-medium" scope="col">Προσωπολογία (visagisme)</th>
            <th className="p-4 font-medium" scope="col">Προσωπομετρία (face metrics)</th>
          </tr>
        </thead>
        <tbody>
          {COMPARISON.map(([label, a, b]) => (
            <tr key={label} className="border-t border-brown/10">
              <th scope="row" className="p-4 font-medium text-warm-black">{label}</th>
              <td className="p-4 text-muted">{a}</td>
              <td className="p-4 text-muted">{b}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}